import React from 'react';
import { AnswerSet } from '../AnswerSets/AnswerSet';

/**
 * A sentiment scale's options are an ordinary likert answer set, so the detail
 * is the shared `AnswerSet`. `defaultGetComponents` maps this type onto the
 * one-option-per-line editor, which is why this file has no markup of its own.
 */
export default function SentimentQuestionDetail({ question, ...props }) {
  return (
    <div>
      <AnswerSet
        {...props}
        answerSet={question.answerSet}
        answerSetConfig={question.answerSetConfig}
        question={question}
      />
    </div>
  );
}
